import { render, staticRenderFns } from "./applicationsTextFields.vue?vue&type=template&id=b1e4efe4&scoped=true&"
import script from "./applicationsTextFields.vue?vue&type=script&lang=js&"
export * from "./applicationsTextFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e4efe4",
  null
  
)

export default component.exports